export function filterNull<T>(array: Array<T | undefined>) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return array.filter((item) => !!item).map((item) => item!); // Non null assertion is safe because of the filter
}
